var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIconInviteFriends = function SvgIconInviteFriends(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF5B9",
    d: "M15.05 13.343A6.9 6.9 0 0 0 11.9 9.68a6.53 6.53 0 0 1-4.164 1.489 6.5 6.5 0 0 1-4.163-1.496C1.44 10.853 0 13.096 0 15.673v2.861c0 .655.54 1.187 1.208 1.187H9.15q-.008-.14-.006-.278c0-3.269 2.629-5.94 5.906-6.1M7.735 9.624c2.705 0 4.898-2.154 4.898-4.812S10.44 0 7.735 0 2.838 2.154 2.838 4.813 5.03 9.625 7.735 9.625"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF5B9",
    d: "M15.36 14.881c-2.563 0-4.64 2.041-4.64 4.56 0 2.517 2.077 4.558 4.64 4.558S20 21.96 20 19.44c0-2.518-2.078-4.559-4.64-4.559"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#176F15",
    d: "M17.805 18.948h-1.988v-2.295h-.903v2.295h-1.987v1.043h1.987v2.295h.903V19.99h1.988z"
  })));
};
export default SvgIconInviteFriends;